<div class="container auth-container">
  <div class="auth-card">
    <h2 class="auth-title">Şifrə təyin et</h2>
    <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" class="auth-form">
      <div class="form-group">
        <label for="password">Yeni şifrə</label>
        <div class="password-wrapper">
          <input
            [type]="showPassword ? 'text' : 'password'"
            id="password"
            formControlName="password"
            placeholder="Şifrənizi daxil edin"
            [class.invalid]="passwordForm.get('password')?.invalid && passwordForm.get('password')?.touched"
          >
          <button type="button" class="toggle-password" (click)="togglePasswordVisibility()">
            <i class="icon" [class.icon-show]="!showPassword" [class.icon-hide]="showPassword"></i>
          </button>
        </div>
        <div class="error-message" *ngIf="passwordForm.get('password')?.invalid && passwordForm.get('password')?.touched">
          <span *ngIf="passwordForm.get('password')?.errors?.['required']">Şifrə daxil edilməlidir.</span>
          <span *ngIf="passwordForm.get('password')?.errors?.['minlength']">Şifrə ən azı 8 simvol olmalıdır.</span>
        </div>
      </div>

      <div class="form-group">
        <label for="confirmPassword">Yeni şifrəni təkrarla</label>
        <div class="password-wrapper">
          <input
            [type]="showConfirmPassword ? 'text' : 'password'"
            id="confirmPassword"
            formControlName="confirmPassword"
            placeholder="Şifrəni təkrar daxil edin"
            [class.invalid]="(passwordForm.get('confirmPassword')?.invalid || passwordForm.errors?.['mismatch']) && passwordForm.get('confirmPassword')?.touched"
          >
          <button type="button" class="toggle-password" (click)="toggleConfirmPasswordVisibility()">
            <i class="icon" [class.icon-show]="!showConfirmPassword" [class.icon-hide]="showConfirmPassword"></i>
          </button>
        </div>
        <div class="error-message" *ngIf="passwordForm.get('confirmPassword')?.touched">
          <span *ngIf="passwordForm.get('confirmPassword')?.errors?.['required']">Şifrəni təkrar daxil edin.</span>
          <span *ngIf="passwordForm.errors?.['mismatch']">Şifrələr uyğun deyil.</span>
        </div>
      </div>

      <button type="submit" class="btn-submit" [disabled]="passwordForm.invalid">Yadda saxla</button>
    </form>
  </div>
</div>
